<template>
    <div v-if="editable">
        <input ref="gg-autocomplete" type="text" :value="one_liner" :class="{'uk-form-warning': highlighted&&required&&!one_liner}" placeholder="Address" class="uk-width-1-1" @change="data_changed" />
    </div>
    <div v-else>
        {{ one_liner }}
    </div>
</template>

<style lang="less">
    .pac-container {
        z-index: 1020 !important;
    }
</style>

<script type="text/javascript">
import { assign } from "lodash"
import utilities from "../mixins/Is"
import auto_saves from "../mixins/AutoSaves"

const addressit = require("addressit")

export default {
    mixins: [utilities, auto_saves],
    mounted () {
        this.setup()
    },
    watch: {
        value: "setup",
        shown: "setup"
    },
    methods: {
        setup () {
            if(this.shown && this.$refs["gg-autocomplete"] && !this.autocomplete) {
                this.autocomplete = new window.google.maps.places.Autocomplete(
                    this.$refs["gg-autocomplete"],
                    { types: ["geocode"] }
                )
                this.autocomplete.addListener("place_changed", (event) => {
                    this.place_changed()
                })
            }
        },
        save_standardized_value (data) {
            if(!this.record.id) {
                data.owner_type = this.record.owner_type
                data.owner_id = this.record.owner_id
                data.address_type = this.record.address_type
            }
            this.saveField(null, data, this.record)
        },
        save (data, field) {
            if(!this.editable) return
            if(this.autocomplete_timer && (!field || (field === "line1"))) {
                clearTimeout(this.autocomplete_timer)
                this.autocomplete_timer = null
            }

            if(!data) {
                data = {
                    line1: "",
                    city: "",
                    state: "",
                    country: "",
                    zip: "",
                    latitude: 0,
                    longitude: 0
                }
                this.save_standardized_value(data)
                // this.$emit('input', data)
                this.$emit("change", field, data, this.record[field])
            } else {
                data = assign({
                    line1: this.record.line1,
                    city: this.record.city,
                    state: this.record.state,
                    country: this.record.country,
                    zip: this.record.zip,
                    latitude: this.record.latitude,
                    longitude: this.record.longitude
                }, data)

                let address = [
                    data.line1,
                    data.city,
                    data.state,
                    data.zip
                ].join(" ")

                if(!this.geocoder) this.geocoder = new window.google.maps.Geocoder()
                this.geocoder.geocode({ address: address }, (results, status) => {
                    address = addressit(data.line1)
                    // console.log("Geocode", status, results, address, data)
                    if(status === "OK") {
                        const place = results[0]
                        let street_number = this.place_component(place, "street_number").short_name
                        if(!street_number && address.number) {
                            street_number = address.number
                            if(address.unit) street_number += "-" + address.unit
                        }
                        data.line1 = this.nibnut_filter("nibnut.concat", [[street_number, this.place_component(place, "route").long_name]])
                        if(!data.line1) data.line1 = this.nibnut_filter("nibnut.concat", [[this.place_component(place, "neighborhood").short_name, this.place_component(place, "sublocality").short_name]])
                        data.city = this.place_component(place, "locality").long_name
                        data.state = this.place_component(place, "administrative_area_level_1").short_name
                        data.country = this.place_component(place, "country").long_name
                        data.zip = this.place_component(place, "postal_code").short_name
                        data.latitude = place.geometry.location.lat()
                        data.longitude = place.geometry.location.lng()

                        this.save_standardized_value(data)
                        // this.$emit('input', data)
                        this.$emit("change", field, data, this.record[field])
                    } else if(status === "ZERO_RESULTS") {
                        if(address.number && address.unit) address.number += "-" + address.unit
                        data.line1 = this.nibnut_filter("nibnut.concat", [[address.number, address.street]])
                        data.city = (address.regions && address.regions.length) ? address.regions[0] : ""
                        data.state = address.state || ""
                        if(!data.state && address.regions && (address.regions.length > 1)) data.state = address.regions[1]
                        data.country = address.country || ""
                        if(!data.country && address.regions && (address.regions.length > 2)) data.country = address.regions[2]
                        if(!data.country) data.country = "United States"
                        data.zip = address.postalcode || ""
                        data.latitude = 0
                        data.longitude = 0
                        // console.log("ZERO RESULT SAVE", data)
                        this.save_standardized_value(data)
                        // this.$emit('input', data)
                        this.$emit("change", field, data, this.record[field])
                    }
                })
            }
        },
        data_changed (event) {
            const data = event.target.value ? { line1: event.target.value } : ""
            this.autocomplete_timer = setTimeout(() => {
                this.save(data, "line1")
            }, 1000)
        },
        place_component (place, component_id) {
            if(place.address_components) {
                const component = place.address_components.find((component) => {
                    return component.types.indexOf(component_id) >= 0
                })
                if(component) return component
            }
            return { short_name: "", long_name: "" }
        },
        place_changed () {
            const place = this.autocomplete.getPlace()

            let line1 = this.nibnut_filter("nibnut.concat", [[this.place_component(place, "street_number").short_name, this.place_component(place, "route").long_name]])
            if(!line1) line1 = this.nibnut_filter("nibnut.concat", [[this.place_component(place, "neighborhood").short_name, this.place_component(place, "sublocality").short_name]])
            if(!line1) line1 = place.name

            // console.log("place_changed", place)
            this.save({
                line1,
                city: this.place_component(place, "locality").long_name,
                state: this.place_component(place, "administrative_area_level_1").short_name,
                country: this.place_component(place, "country").long_name,
                zip: this.place_component(place, "postal_code").short_name
            })
        }
    },
    computed: {
        record () {
            return this.value || {}
        },
        one_liner () {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            if(this.record.line1) this.record.line1 = this.record.line1.trim()
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            if(this.record.city) this.record.city = this.record.city.trim()
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            if(this.record.state) this.record.state = this.record.state.trim()
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            if(this.record.country) this.record.country = this.record.country.trim()
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            if(this.record.zip) this.record.zip = this.record.zip.trim()

            return this.nibnut_filter("nibnut.concat", [[this.record.line1, this.record.city, this.record.state, this.record.country, this.record.zip], ", "])
        },
        states () {
            return [
                { id: "AL", name: "Alabama" },
                { id: "AK", name: "Alaska" },
                { id: "AS", name: "American Samoa" },
                { id: "AZ", name: "Arizona" },
                { id: "AR", name: "Arkansas" },
                { id: "CA", name: "California" },
                { id: "CO", name: "Colorado" },
                { id: "CT", name: "Connecticut" },
                { id: "DE", name: "Delaware" },
                { id: "DC", name: "District Of Columbia" },
                { id: "FM", name: "Federated States Of Micronesia" },
                { id: "FL", name: "Florida" },
                { id: "GA", name: "Georgia" },
                { id: "GU", name: "Guam" },
                { id: "HI", name: "Hawaii" },
                { id: "ID", name: "Idaho" },
                { id: "IL", name: "Illinois" },
                { id: "IN", name: "Indiana" },
                { id: "IA", name: "Iowa" },
                { id: "KS", name: "Kansas" },
                { id: "KY", name: "Kentucky" },
                { id: "LA", name: "Louisiana" },
                { id: "ME", name: "Maine" },
                { id: "MH", name: "Marshall Islands" },
                { id: "MD", name: "Maryland" },
                { id: "MA", name: "Massachusetts" },
                { id: "MI", name: "Michigan" },
                { id: "MN", name: "Minnesota" },
                { id: "MS", name: "Mississippi" },
                { id: "MO", name: "Missouri" },
                { id: "MT", name: "Montana" },
                { id: "NE", name: "Nebraska" },
                { id: "NV", name: "Nevada" },
                { id: "NH", name: "New Hampshire" },
                { id: "NJ", name: "New Jersey" },
                { id: "NM", name: "New Mexico" },
                { id: "NY", name: "New York" },
                { id: "NC", name: "North Carolina" },
                { id: "ND", name: "North Dakota" },
                { id: "MP", name: "Northern Mariana Islands" },
                { id: "OH", name: "Ohio" },
                { id: "OK", name: "Oklahoma" },
                { id: "OR", name: "Oregon" },
                { id: "PW", name: "Palau" },
                { id: "PA", name: "Pennsylvania" },
                { id: "PR", name: "Puerto Rico" },
                { id: "RI", name: "Rhode Island" },
                { id: "SC", name: "South Carolina" },
                { id: "SD", name: "South Dakota" },
                { id: "TN", name: "Tennessee" },
                { id: "TX", name: "Texas" },
                { id: "UT", name: "Utah" },
                { id: "VT", name: "Vermont" },
                { id: "VI", name: "Virgin Islands" },
                { id: "VA", name: "Virginia" },
                { id: "WA", name: "Washington" },
                { id: "WV", name: "West Virginia" },
                { id: "WI", name: "Wisconsin" },
                { id: "WY", name: "Wyoming" }
            ]
        }
    },
    props: {
        editable: {
            type: Boolean,
            default: true
        },
        shown: {
            type: Boolean,
            default: true
        },
        highlighted: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            geocoder: null,
            autocomplete: null,
            autocomplete_timer: null
        }
    }
}
</script>
